import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Uris } from '../public/Uris';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { GlobalFunction } from '../public/globalFunction';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public GlobalFunction: GlobalFunction
  ) {}

  getSettings() {
    return this.http
      .get(`${Uris.SETTINGS}`, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  createSettings(object) {
    return this.http
      .post(`${Uris.SETTINGS}`, object, this.GlobalFunction.headers())
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  patchSettings(object) {
    return this.http
      .patch(
        `${Uris.SETTINGS}${object.id}/`,
        object,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }
}
